import { render, staticRenderFns } from "./column-with-group.vue?vue&type=template&id=4a42ff03"
import script from "./column-with-group.vue?vue&type=script&lang=js"
export * from "./column-with-group.vue?vue&type=script&lang=js"
import style0 from "./column-with-group.vue?vue&type=style&index=0&id=4a42ff03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports